import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AppService } from 'app/app.service';

@Injectable({
    providedIn: 'root',
})
export class FileManagerService {
    private _data: BehaviorSubject<any> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private appService: AppService
    ) { }


    download(filename: string) {
        return this._httpClient.get(
            this.appService.getApiUrl() + 'service/download/' + filename, { responseType: 'blob' }
        );
    }
}
